import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Vouchers from "@/pages/Vouchers";
import VoucherForm from "@/pages/VoucherForm";
import VoucherDetail from "@/pages/VoucherDetail";
import Vendors from "@/pages/Vendors";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import UsersPage from "@/pages/Users";
import { Loader2 } from "lucide-react";

function Protected({ children, adminOnly }) {
  const { user, isAdmin } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
        <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/vouchers" element={<Protected><Vouchers /></Protected>} />
      <Route path="/cc" element={<Protected><Vouchers key="cc" cc /></Protected>} />
      <Route path="/vouchers/new" element={<Protected><VoucherForm /></Protected>} />
      <Route path="/vouchers/:id" element={<Protected><VoucherDetail /></Protected>} />
      <Route path="/vouchers/:id/edit" element={<Protected><VoucherForm /></Protected>} />
      <Route path="/vendors" element={<Protected><Vendors /></Protected>} />
      <Route path="/audit" element={<Protected adminOnly><AuditLog /></Protected>} />
      <Route path="/users" element={<Protected adminOnly><UsersPage /></Protected>} />
      <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
